/** The available shift request actions. */
export enum ShiftRequestAction {
    /** The action to approve a request. */
    Approve = "Approve",

    /** The action to deny a request. */
    Deny = "Deny"
}